import { DateTime, Info } from "luxon";
import { TFunction } from "i18next";
import {
  FlueBurnMetricAggregateTimeUnit,
  flueBurnMetricAggregateTimeUnits,
} from "../../../chimney/flue/metrics/FlueBurnMetricAggregateTimeUnit";

export const resolveTimeUnitLabel = (
  t: TFunction<"firefly-shared-ts-domain">,
  timeUnit: FlueBurnMetricAggregateTimeUnit,
  time?: DateTime
): string => {
  if (timeUnit === flueBurnMetricAggregateTimeUnits.ever) {
    return t("TimeUnit.ever");
  } else if (timeUnit === flueBurnMetricAggregateTimeUnits.sinceSweep) {
    return t("TimeUnit.sinceSweep");
  } else if (
    timeUnit === flueBurnMetricAggregateTimeUnits.atSensorOperational
  ) {
    return t("Sensor Operational");
  } else if (
    timeUnit === flueBurnMetricAggregateTimeUnits.year &&
    time !== undefined
  ) {
    return `${time.year}`;
  } else if (
    timeUnit === flueBurnMetricAggregateTimeUnits.month &&
    time !== undefined
  ) {
    return `${Info.months()[time.month - 1]}`;
  } else {
    return "?";
  }
};
